import React from "react"

import Layout from "~/layouts"
import SEO from "~/components/seo"
import { Container } from "~/styles/Elements"

const IndexPage = () => (
  <Layout>
    <Container>
      <SEO title="Home" />
      <h1>Frontend Gutenberg Blocks</h1>
      <p>View the various posts containing examples of blocks from Wordpress</p>
    </Container>
  </Layout>
)

export default IndexPage
